/* CARE — Diagnostic : scoring, duo, buy box V3 (prix réels Recharge) */
(function(){
  var AXES = ['sommeil','energie','focus','anti-stress','defense'];
  var ICONS = { sommeil:'🌙', energie:'⚡', focus:'🧠', 'anti-stress':'🌿', defense:'🛡️' };

  function initQuiz(root){
    var tag = root.querySelector('[data-quiz-data]');
    if(!tag) return;
    var D;
    try { D = JSON.parse(tag.textContent); } catch(e){ return; }

    var QS = D.questions || [];
    if(!QS.length) return;
    var LAB = D.labels || {}, P = D.products || {};
    var $ = function(sel){ return root.querySelector(sel); };

    var steps   = root.querySelectorAll('.carequiz__step');
    var qStep   = root.querySelector('[data-step="q"]');
    var fill    = $('[data-quiz-fill]');
    var stepn   = $('[data-quiz-stepn]');
    var backBtn = $('[data-quiz-back]');
    var hasEmail= !!root.querySelector('[data-step="email"]');

    var answers = [], qi = 0, state = 'intro';
    var picks = [], mode = 'sub', days = parseInt(D.default_days,10) || 90;

    /* ---------- money ---------- */
    var MF = D.money_format || '{{amount_with_comma_separator}}€';
    function money(cents){
      var n = (cents/100);
      var withComma = n.toFixed(2).replace('.', ',');
      var withDot   = n.toFixed(2);
      var noDec     = Math.round(n).toString();
      return MF
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDec)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDec)
        .replace(/\{\{\s*amount\s*\}\}/g, withDot);
    }

    /* ---------- navigation ---------- */
    function show(name){
      steps.forEach(function(s){ s.classList.toggle('is-active', s.dataset.step === name); });
      state = name;
      if(backBtn) backBtn.hidden = (name !== 'q');
      progress();
    }
    function progress(){
      var total = QS.length, p = 0;
      if(state === 'q') p = Math.round((qi/total)*100);
      else if(state !== 'intro') p = 100;
      if(fill) fill.style.width = p + '%';
      if(stepn) stepn.textContent = (state === 'q') ? (qi+1)+'/'+total : '';
    }

    /* ---------- questions ---------- */
    function renderQ(){
      var Q = QS[qi];
      var h = '<span class="carequiz__eyebrow">Question '+(qi+1)+'</span><p class="carequiz__q">'+Q.q+'</p><div class="carequiz__opts">';
      (Q.o||[]).forEach(function(o){
        if(!o[1]) return;
        h += '<button type="button" class="carequiz__opt" data-f="'+o[0]+'"><span class="carequiz__ic">'+(ICONS[o[0]]||'')+'</span>'+o[1]+'</button>';
      });
      qStep.innerHTML = h + '</div>';
      qStep.querySelectorAll('.carequiz__opt').forEach(function(b){
        b.addEventListener('click', function(){
          answers[qi] = { k: b.dataset.f, w: Q.w || 1 };
          qi++;
          if(qi >= QS.length){ hasEmail ? show('email') : runAnalyse(); }
          else { renderQ(); show('q'); }
        });
      });
      show('q');
    }
    function scores(){
      var s = {}; AXES.forEach(function(a){ s[a] = 0; });
      answers.forEach(function(a){ if(a && s[a.k] !== undefined) s[a.k] += a.w; });
      return s;
    }

    /* ---------- analyse ---------- */
    function runAnalyse(){
      show('analyse');
      var box = $('[data-quiz-anrows]'); if(!box) return renderResult();
      box.innerHTML = AXES.map(function(a){
        return '<div class="carequiz__anrow"><span class="carequiz__anlab">'+(LAB[a]||a)+'</span><span class="carequiz__ant"><span class="carequiz__anf" data-k="'+a+'"></span></span></div>';
      }).join('');
      var s = scores(), max = Math.max.apply(null, AXES.map(function(a){ return s[a]; })) || 1;
      setTimeout(function(){
        box.querySelectorAll('.carequiz__anf').forEach(function(f,i){
          setTimeout(function(){ f.style.width = Math.round((s[f.dataset.k]/max)*100)+'%'; }, i*110);
        });
      }, 120);
      setTimeout(renderResult, 1500);
    }

    /* ---------- résultat ---------- */
    function renderResult(){
      var s = scores();
      var sorted = AXES.slice().sort(function(a,b){ return s[b]-s[a]; });
      var totalW = QS.reduce(function(t,q){ return t + (q.w||1); }, 0);
      var s1 = s[sorted[0]], s2 = s[sorted[1]];
      var duo = D.duo || {};
      var isDuo = !!duo.enable && s2 >= 2 && s1 > 0 && (s2/s1)*100 >= (duo.ratio || 66);
      picks = isDuo ? [sorted[0], sorted[1]] : [sorted[0]];

      var p1 = P[picks[0]] || {};
      var img1 = $('[data-quiz-rimg]'), img2 = $('[data-quiz-rimg2]');
      if(img1 && p1.img){ img1.src = p1.img; img1.alt = p1.title || ''; }
      if(img2){
        if(isDuo && P[picks[1]] && P[picks[1]].img){ img2.src = P[picks[1]].img; img2.alt = P[picks[1]].title || ''; img2.hidden = false; }
        else img2.hidden = true;
      }

      var title = $('[data-quiz-rtitle]'), why = $('[data-quiz-rreason]'), match = $('[data-quiz-match]');
      var R = D.reasons || {};
      if(isDuo){
        if(title) title.textContent = (LAB[picks[0]]||'') + ' + ' + (LAB[picks[1]]||'');
        if(why){
          var r2 = R[picks[1]] || '';
          why.textContent = (duo.intro || '') + ' ' + (R[picks[0]]||'') + (r2 ? ' En complément, ' + r2.charAt(0).toLowerCase() + r2.slice(1) : '');
        }
        if(match) match.textContent = duo.label || '';
      } else {
        if(title) title.textContent = LAB[picks[0]] || (p1.title || 'CARE');
        if(why) why.textContent = R[picks[0]] || '';
        var pct = Math.round((s1/totalW)*100), M = D.match || {};
        if(match) match.textContent = pct >= (M.threshold || 60) ? (M.strong||'') : (M.normal||'');
      }

      renderBars(s, sorted, totalW);
      renderRecent();
      renderBuybox();
      show('result');
    }

    function renderBars(s, sorted, totalW){
      var box = $('[data-quiz-bars]'); if(!box) return;
      var max = s[sorted[0]] || 1;
      box.innerHTML = sorted.map(function(a){
        var v = s[a], w = Math.round((v/max)*100), win = picks.indexOf(a) > -1;
        return '<div class="carequiz__brow'+(win?' is-win':'')+'" title="'+(LAB[a]||a)+' : '+v+'/'+totalW+'">'+
          '<span class="carequiz__blab">'+(LAB[a]||a)+'</span>'+
          '<span class="carequiz__btrack"><span class="carequiz__bfill" data-w="'+w+'"></span></span>'+
          '<span class="carequiz__bval">'+v+'</span></div>';
      }).join('');
      setTimeout(function(){
        box.querySelectorAll('.carequiz__bfill').forEach(function(f,i){
          setTimeout(function(){ f.style.width = f.dataset.w+'%'; }, i*80);
        });
      }, 120);
    }

    function renderRecent(){
      var spark = $('[data-quiz-spark]'); if(!spark) return;
      var cfg = D.recent || {};
      var daily = String(cfg.daily||'').split(',').map(function(n){ return parseInt(n,10)||0; }).filter(function(n,i){ return i < 7; });
      if(!daily.length) return;
      var total = daily.reduce(function(a,b){ return a+b; }, 0);
      var dmax = Math.max.apply(null, daily) || 1;
      var INIT = ['D','L','M','M','J','V','S'], today = new Date().getDay();
      var n = $('[data-quiz-recent]'), t = $('[data-quiz-recenttxt]');
      if(n) n.textContent = total;
      if(t) t.textContent = String(cfg.text||'').replace('[formule]', LAB[picks[0]]||'');
      spark.innerHTML = daily.map(function(v,i){
        var last = (i === daily.length-1);
        var d = new Date(); d.setDate(d.getDate()-(daily.length-1-i));
        return '<span class="carequiz__sbcol'+(last?' is-on':'')+'" title="'+v+' le '+d.toLocaleDateString('fr-FR',{day:'numeric',month:'short'})+'">'+
               '<span class="carequiz__sbar" data-h="'+Math.round((v/dmax)*100)+'"></span></span>';
      }).join('');
      var sd = $('[data-quiz-sdays]');
      if(sd) sd.innerHTML = daily.map(function(v,i){
        return '<span class="carequiz__sday">'+INIT[(today-(daily.length-1-i)+7)%7]+'</span>';
      }).join('');
      setTimeout(function(){
        spark.querySelectorAll('.carequiz__sbar').forEach(function(b,i){
          setTimeout(function(){ b.style.height = b.dataset.h+'%'; }, i*60);
        });
      }, 260);
    }

    /* ---------- buy box V3 (prix réels) ---------- */
    function totals(d){
      var qty = d/30, once = 0, sub = 0;
      picks.forEach(function(k){
        var p = P[k] || {}, pl = (p.plans||{})[String(d)] || {};
        once += (p.price||0) * qty;
        sub  += (pl.price || p.price || 0) * qty;
      });
      return { once: once, sub: sub, days: d, off: once ? Math.round((1 - sub/once)*100) : 0 };
    }
    function renderBuybox(){
      var durs = $('[data-quiz-durs]');
      if(durs){
        durs.innerHTML = (D.durations||[]).map(function(x){
          var t = totals(x.d);
          return '<button type="button" class="carequiz__dur'+(x.d===days?' is-on':'')+'" data-d="'+x.d+'">'+
            '<span class="carequiz__strip '+(x.cls||'')+'">'+x.strip+'</span>'+
            '<span class="carequiz__durb"><span class="carequiz__durd">'+x.d+' jours</span>'+
            '<span class="carequiz__durp">'+money(t.sub/t.days)+'<small> /jour</small></span>'+
            (t.off>0 ? '<span class="carequiz__durbadge">-'+t.off+'%</span>' : '')+'</span></button>';
        }).join('');
        durs.querySelectorAll('.carequiz__dur').forEach(function(el){
          el.addEventListener('click', function(){ days = parseInt(el.dataset.d,10); renderBuybox(); });
        });
      }
      var t = totals(days);
      var set = function(sel, html){ var el = $(sel); if(el) el.innerHTML = html; };
      set('[data-quiz-subbadge]', t.off>0 ? '-'+t.off+'%' : '');
      set('[data-quiz-subday]',  money(t.sub/t.days)+'<small> /jour</small>');
      set('[data-quiz-subtot]',  money(t.sub)+(t.once>t.sub ? ' <s>'+money(t.once)+'</s>' : ''));
      set('[data-quiz-onceday]', money(t.once/t.days)+'<small> /jour</small>');
      set('[data-quiz-oncetot]', money(t.once)+' au total');

      root.querySelectorAll('[data-quiz-mode]').forEach(function(r){
        r.classList.toggle('is-on', r.dataset.quizMode === mode);
      });
      var kit = $('[data-quiz-kit]'), kt = $('[data-quiz-kittitle]'), K = D.kit || {};
      if(kit) kit.classList.toggle('is-locked', mode !== 'sub');
      if(kt) kt.textContent = mode === 'sub' ? (K.on||'') : (K.off||'');

      var add = $('[data-quiz-add]'), C = D.cta || {};
      if(add){
        add.textContent = mode === 'sub'
          ? (C.sub||'') + ' ' + String(C.save||'').replace('[montant]', money(t.once - t.sub))
          : String(C.once||'').replace('[montant]', money(t.once));
      }
    }
    root.querySelectorAll('[data-quiz-mode]').forEach(function(r){
      r.addEventListener('click', function(){ mode = r.dataset.quizMode; renderBuybox(); });
    });

    /* ---------- ajout au panier (duo = 2 lignes) ---------- */
    var addBtn = $('[data-quiz-add]');
    if(addBtn) addBtn.addEventListener('click', function(){
      var qty = days/30, items = [];
      picks.forEach(function(k){
        var p = P[k] || {}; if(!p.vid) return;
        var item = { id: p.vid, quantity: qty };
        if(mode === 'sub'){
          var pl = (p.plans||{})[String(days)] || {};
          if(pl.id) item.selling_plan = pl.id;
        }
        items.push(item);
      });
      if(!items.length){ if(P[picks[0]] && P[picks[0]].url) window.location.href = P[picks[0]].url; return; }
      if(window.CareCart && window.CareCart.addItems){ window.CareCart.addItems(items); }
      else { window.location.href = '/cart'; }
    });

    /* ---------- email ---------- */
    var emailInput = $('[data-quiz-email]'), emailErr = $('[data-quiz-err]');
    var reveal = $('[data-quiz-reveal]'), skip = $('[data-quiz-skip]');
    if(reveal) reveal.addEventListener('click', function(){
      var v = emailInput ? emailInput.value.trim() : '';
      if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)){ if(emailErr) emailErr.hidden = false; return; }
      if(emailErr) emailErr.hidden = true;
      var fd = new FormData();
      fd.append('form_type','customer'); fd.append('utf8','✓');
      fd.append('contact[email]', v); fd.append('contact[tags]','diagnostic');
      fetch('/contact', { method:'POST', body:fd, headers:{ 'Accept':'application/json' } }).catch(function(){});
      runAnalyse();
    });
    if(skip) skip.addEventListener('click', runAnalyse);

    /* ---------- contrôles ---------- */
    var start = $('[data-quiz-start]');
    if(start) start.addEventListener('click', function(){ qi = 0; answers = []; renderQ(); });
    if(backBtn) backBtn.addEventListener('click', function(){
      if(qi > 0){ qi--; renderQ(); } else { show('intro'); }
    });
    var restart = $('[data-quiz-restart]');
    if(restart) restart.addEventListener('click', function(){
      qi = 0; answers = []; picks = []; mode = 'sub';
      days = parseInt(D.default_days,10) || 90;
      if(emailInput) emailInput.value = '';
      show('intro');
    });

    progress();
  }

  function boot(){ document.querySelectorAll('.carequiz').forEach(initQuiz); }
  if(document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
